<div class="d-flex justify-content-center w-100"
  #anchor>
  <div class="loader">
    <mat-spinner [diameter]="diameter"
      *ngIf="isLoading"></mat-spinner>
  </div>
</div>